import { render, staticRenderFns } from "./MenuPages.vue?vue&type=template&id=368354a0&scoped=true"
import script from "./MenuPages.vue?vue&type=script&lang=js"
export * from "./MenuPages.vue?vue&type=script&lang=js"
import style0 from "./MenuPages.vue?vue&type=style&index=0&id=368354a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "368354a0",
  null
  
)

export default component.exports